import { render, staticRenderFns } from "./StemdoerPage.vue?vue&type=template&id=00c889e2"
import script from "./StemdoerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StemdoerPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports